import React, { FC } from 'react';
import "./PreferenceCard.scss";
import { PropsType } from './PreferenceCardTypes';


export const PreferenceCard: FC<PropsType> = (props) => {

  let { heading, description, img,moduleTypeNames,cardClickHandler,shouldDisplay } = props;
  
  return (
    <div className={'preference-card-wrap'} data-active={(shouldDisplay)?'active':'inactive'}  onClick={()=>cardClickHandler(moduleTypeNames,shouldDisplay)}>
      <div className="preference-card">
        <div className="card-img-container">
          <img src={img} className="card-img" alt="appimg" />
        </div>
        <div className="card-details-container">
          <div className="card-heading">
            {heading}
          </div>
          <div className='card-description'>
            {description}
          </div>
        </div>

      </div>
    </div>


  )
}
